const getCurrentHref = () => window.location.href;

export const SEO_DEFAULTS = {
  TITLE: 'SnapTest - Generate & maintain automated QA tests easily',
  DESCRIPTION: 'Record, build, debug, and maintain quality QA in Google Chrome with SnapTest. Generate quality Selenium code to be run from anywhere. ',
  KEYWORDS: ''
}

export const SOCIAL = {
  FACEBOOK: {},
  TWITTER: {}
};



// WEBPACK FOOTER //
// ./src/constants.js